import moment from 'moment'

export function convertTimeToString (time, lang) {
  return moment(time).locale(lang).calendar()
}